<ui-modal
  [isOpened]="modalOpen"
  modalTitle="Fixing Sources"
  (isOpenedChange)="modalChanged($event)"
>
  <div class="currency-pairs">
    <table ui-table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Time</th>
          <th>Timezone</th>
        </tr>
        <tr *ngFor="let r of sources">
          <td>{{ r.longName }}</td>
          <td>{{ r.time?.substr(0, 5) }}</td>
          <td>{{ r.timezone }}</td>
        </tr>
      </thead>
    </table>
  </div>
</ui-modal>
